const reportWebVitals = (onPerfEntry: () => void = console.log) => {
  if (onPerfEntry && onPerfEntry instanceof Function)
    import('web-vitals').then(({ onCLS, onFCP, onLCP, onTTFB }) => {
      onCLS(onPerfEntry);
      onFCP(onPerfEntry);
      onLCP(onPerfEntry);
      onTTFB(onPerfEntry);
    });
};

export default reportWebVitals;
